<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" :title="!dataForm.id ? '新增' : '编辑'" width="680px" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="150px" v-loading="dialogLoading">
      <el-form-item prop="contractId" label="关联合同">
        <el-select style="width: 100%;" v-model="dataForm.contractId" :disabled="dataForm.id" placeholder="请选择关联合同" filterable autocomplete="off" clearable>
          <el-option v-for="item in contactList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="name" label="项目名称">
        <el-input v-model="dataForm.name" autocomplete="off" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item prop="number" label="项目编号">
        <el-input v-model="dataForm.number" :disabled="dataForm.id" autocomplete="off" placeholder="请输入" clearable></el-input>
      </el-form-item> -->
      <el-form-item prop="remark" label="备注">
        <el-input v-model="dataForm.remark" autocomplete="off" placeholder="请输入" clearable></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'addOrUpdate',
  props: {
    contactList: Array
  },
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      size: 'small',
      dialogLoading: false,
      visible: false,
      serversList: [],
      clientServersList: [],
      dataForm: {
        contractId: '',
        name: '',
        // number: '',
        remark: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        contractId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (row) {
      this.visible = true
      this.dataForm = {
        contractId: '',
        name: '',
        // number: '',
        remark: ''
      }
      console.log(row)
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (row !== null) {
          this.dataForm = Object.assign({}, {
            id: row.projectId,
            projectId: row.projectId,
            contractId: row.contractId,
            name: row.projectName,
            number: row.projectNumber,
            remark: row.projectRemark
          })
        }
        console.log(this.dataForm)
      })
    },
    submitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dialogLoading = true
        if (this.dataForm.id) {
          this.$api.contract.updateContractProjectName({ ...this.dataForm }).then((res) => {
            this.dialogLoading = false
            if (res.success) {
              this.$message.success('操作成功')
              this.visible = false
              this.$emit('handleQuery')
            }
          })
        } else {
          this.$api.contract.addContractProject({ ...this.dataForm }).then((res) => {
            this.dialogLoading = false
            if (res.success) {
              this.$message.success('操作成功')
              this.visible = false
              this.$emit('handleQuery')
            }
          })
        }
      })
    }, 1000, { 'leading': true, 'trailing': false }) 
  }
}
</script>

<style lang="scss" scoped>
.dialog-simple {
  text-align: left;
}
</style>
